export const SUCCESS_SETUP_CONTENTREPO = "SUCCESS_SETUP_CONTENTREPO";
export const LOADING_SETUP_CONTENTREPO = "LOADING_SETUP_CONTENTREPO";
